import { Roles } from "../../constants/roles";
import type { PostsAdsHandler } from "./posts-ads-handler";
import { postsAdsFormBase } from "./posts-ads-form";

interface ContentInsertedDetail {
    root?: Element | null;
}

export class PostsAdsListener {
    private readonly handler: PostsAdsHandler;

    private readonly onContentInsertedBound: (event: Event) => void;

    public constructor(handler: PostsAdsHandler) {
        this.handler = handler;
        this.onContentInsertedBound = this.onContentInserted.bind(this);
    }

    public register(): void {
        document.addEventListener("app:content:inserted", this.onContentInsertedBound);
    }

    private onContentInserted(event: Event): void {
        if (!(event instanceof CustomEvent)) return;

        const detail = event.detail as ContentInsertedDetail | undefined;
        const root = detail?.root;
        if (!(root instanceof Element)) return;
        const isPostsListRoot = root.matches?.(`[data-list-type="${Roles.POSTS_LIST}"]`) === true;
        const isPostCardRoot = root.matches?.(`[data-role="${Roles.POST_CARD}"]`) === true;
        if (!isPostsListRoot && !isPostCardRoot && !postsAdsFormBase.hasPostCard(root)) {
            return;
        }

        void this.handler.applyAdsToPendingCards();
    }
}
